export default "__VITE_ASSET__IXPAv4TZ__";